/* Stylesheet */

.swiper_controls {
  padding: 0;

  .row {
    padding: 0;
    height: 100%;

    .col {
      padding: 0px 28px 0px 28px;
      height: 52px;
      display: flex;
      align-items: center;
    }

    .bullet_container_col {
      justify-content: center;
    }

    .pagination_col {
      justify-content: flex-end;
    }
  }
}
